module.exports = __webpack_public_path__ + "static/media/udemy.905b9766.svg";